/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendSparkPaymentRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {SendSparkPaymentResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const sendSparkPayment = (request: SendSparkPaymentRequest, options?: CashRequestOptions) => post<SendSparkPaymentRequest, SendSparkPaymentResponse>("/2.0/cash/send-spark-payment", request, {...options, rejectOnError: true })